import { DownloadOutlined } from '@ant-design/icons'
import { Card, Space, Typography } from 'antd'
import { CopyBlock, dracula } from 'react-code-blocks'
import { useTenant } from '../../modules/tenant/contexts/tenant/TenantContext'

const { Title, Text } = Typography

const DownloadLinkCard = () => {
  const { tenant } = useTenant()
  return (
    <Space orientation="vertical" className="w-full">
      <Space className="w-full space-between">
        <Title level={5} className="m-0">
          <DownloadOutlined /> Download app url
        </Title>
      </Space>
      <Card>
        <Space className="w-full" orientation="vertical" size={20}>
          <CopyBlock
            text={`${tenant.appCenterBaseUrl}/download`}
            language={'html'}
            theme={dracula}
            customStyle={{ padding: '12px' }}
          />
          <Text type="secondary">
            This link, when used on a mobile device, automatically redirects
            users to the appropriate store based on their mobile OS (Play Store
            for Android / App Store for iOS). On a desktop, it displays a page
            with QR codes to download the app.
          </Text>
        </Space>
      </Card>
    </Space>
  )
}

type DownloadLinkCardType = { DownloadLinkCard: typeof DownloadLinkCard }

export { DownloadLinkCard, type DownloadLinkCardType }
